<template>
	<v-container fluid>
		<PersonModal
			:maxGuests="personModalMaxGuests"
			:id="0"
			:multiple="true"
			:show="personModalShow"
			:tourgroupid="personModalTourGroupId"
			@callback="personModalCallback"
		/>
		<Email
			:entity="'tours-groups'"
			:objectId="sendTourGroupModalId"
			:show="sendTourGroupModalShow"
			@callback="sendTourGroupModalCallback"
		/>
		<Email
			:entity="'tours-groups-guests'"
			:objectId="sendTourGroupGuestModalId"
			:show="sendTourGroupGuestModalShow"
			@callback="sendTourGroupGuestModalCallback"
		/>
		<Payment
			:id="paymentModal.id"
			:invoice="paymentModal.invoice_id"
			:show="paymentModal.show"
			@callback="paymentModalCallback"
		/>
		<v-dialog v-model="guestModalShow" :persistent="true" max-width="480">
			<v-card>
				<v-card-text>
					<v-layout row wrap>
						<v-flex xs12>
							<Dropdown
								v-model="guest.person_id"
								:ajax="true"
								:data="'people-buyers'"
								:error="guestValidation.person_id"
								:label="'* ' + $t('fields.guest')"
							></Dropdown>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancelGuestModal">{{
						$t("buttons.cancel")
					}}</v-btn>
					<v-btn @click="okGuestModal">{{ $t("buttons.ok") }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<div class="bottom-buttons-outer">
			<v-btn color="success" @click="backClick">
				<v-icon small>fa-reply</v-icon>&nbsp;{{ $t("buttons.back") }}
			</v-btn>
			<v-btn v-if="tour.id == 0" color="success" @click="saveClick">
				<v-icon small>fa-save</v-icon>&nbsp;{{ $t("buttons.save") }}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card>
					<v-card-text>
						<v-tabs v-model="tabId">
							<v-tab>{{ $t("tabs.general") }}</v-tab>
							<v-tab
								v-if="
									tour.id != 0 &&
										$myStore.state.user.user_role_id != 2 &&
										$myStore.state.user.user_role_id != 4
								"
							>
								{{ $t("tabs.billingGroups") }}
							</v-tab>
							<v-tab
								v-if="
									tour.id != 0 &&
										$myStore.state.user.user_role_id != 2
								"
								>{{ $t("tabs.suppliers") }}
							</v-tab>
							<v-tab
								v-if="
									tour.id != 0 &&
										$myStore.state.user.user_role_id != 2 &&
										$myStore.state.user.user_role_id != 4
								"
								>{{ $t("tabs.tourProfit") }}
							</v-tab>
							<v-tab-item>
								<v-layout pt-3 row wrap>
									<v-flex md4 sm6 xs12>
										<v-layout row wrap>
											<v-flex v-if="tour.id != 0" xs12>
												<InputField
													v-model="tour.id"
													:error="tourValidation.id"
													:label="$t('fields.id')"
													readonly
												></InputField>
											</v-flex>
											<v-flex xs12>
												<InputField
													v-model="tour.name"
													:error="tourValidation.name"
													:label="
														'* ' + $t('fields.name')
													"
													:readonly="
														$myStore.state.user
															.user_role_id ==
															2 ||
															$myStore.state.user
																.user_role_id ==
																4
													"
												></InputField>
											</v-flex>
											<v-flex xs12>
												<Dropdown
													v-model="
														tour.tour_category_id
													"
													:ajax="true"
													:data="'tour-categories'"
													:error="
														tourValidation.tour_category_id
													"
													:label="
														'* ' +
															$t(
																'fields.category'
															)
													"
													:readonly="
														$myStore.state.user
															.user_role_id ==
															2 ||
															$myStore.state.user
																.user_role_id ==
																4
													"
												></Dropdown>
											</v-flex>
											<v-flex xs12>
												<Dropdown
													v-model="
														tour.destination_id
													"
													:ajax="true"
													:data="'destinations'"
													:error="
														tourValidation.destination_id
													"
													:label="
														'* ' +
															$t(
																'fields.destination'
															)
													"
													:readonly="
														$myStore.state.user
															.user_role_id ==
															2 ||
															$myStore.state.user
																.user_role_id ==
																4
													"
												></Dropdown>
											</v-flex>
											<v-flex xs12>
												<DatePicker
													v-model="tour.start_date"
													:dateLabel="
														$t('fields.startDate')
													"
													:error="
														tourValidation.start_date
													"
													:readonly="
														$myStore.state.user
															.user_role_id ==
															2 ||
															$myStore.state.user
																.user_role_id ==
																4
													"
												/>
											</v-flex>
											<v-flex xs12>
												<DatePicker
													v-model="tour.end_date"
													:dateLabel="
														$t('fields.endDate')
													"
													:error="
														tourValidation.end_date
													"
													:readonly="
														$myStore.state.user
															.user_role_id ==
															2 ||
															$myStore.state.user
																.user_role_id ==
																4
													"
												/>
											</v-flex>
											<v-flex xs12>
												<TextArea
													v-model="tour.meeting_point"
													:error="
														tourValidation.meeting_point
													"
													:label="
														$t(
															'fields.meetingPoint'
														)
													"
													:readonly="
														$myStore.state.user
															.user_role_id ==
															2 ||
															$myStore.state.user
																.user_role_id ==
																4
													"
												/>
											</v-flex>
											<v-flex xs12>
												<TextArea
													v-model="tour.departure"
													:error="
														tourValidation.departure
													"
													:label="
														$t('fields.departure')
													"
													:readonly="
														$myStore.state.user
															.user_role_id ==
															2 ||
															$myStore.state.user
																.user_role_id ==
																4
													"
												/>
											</v-flex>
										</v-layout>
									</v-flex>
									<v-flex md4 sm6 xs12>
										<v-flex
											v-if="
												tour.id != 0 &&
													(guestsCount > 0 ||
														tour.services.length >
															0)
											"
											xs12
										>
											<v-layout row wrap>
												<v-spacer></v-spacer>
												<v-tooltip bottom>
													<v-icon
														slot="activator"
														:class="{
															'mr-2': true,
															'error--text': !formsSent,
															'primary--text': formsSent
														}"
													>
														fa-envelope
													</v-icon>
													<span>{{
														formsSentTooltip
													}}</span>
												</v-tooltip>
												<v-tooltip
													v-if="showDepositsPaid"
													bottom
												>
													<v-icon
														slot="activator"
														:class="{
															'mr-2': true,
															'error--text': !depositsPaid,
															'primary--text': depositsPaid
														}"
													>
														fa-coins
													</v-icon>
													<span>{{
														depositsPaidTooltip
													}}</span>
												</v-tooltip>
												<v-tooltip
													v-if="showBalancesPaid"
													bottom
												>
													<v-icon
														slot="activator"
														:class="{
															'mr-2': true,
															'error--text': !balancesPaid,
															'primary--text': balancesPaid
														}"
													>
														fa-money-bill
													</v-icon>
													<span>{{
														balancesPaidTooltip
													}}</span>
												</v-tooltip>
												<v-tooltip
													v-if="showSuppliersPaid"
													bottom
												>
													<v-icon
														slot="activator"
														:class="{
															'error--text': !servicesPaid,
															'primary--text': servicesPaid
														}"
													>
														fa-home
													</v-icon>
													<span>{{
														servicesPaidTooltip
													}}</span>
												</v-tooltip>
											</v-layout>
										</v-flex>
										<v-flex v-if="tour.id != 0" xs12>
											<v-layout
												v-if="
													!tour.cancelled &&
														$myStore.state.user
															.user_role_id != 2
												"
												row
												wrap
											>
												<v-spacer />
												<v-btn
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
													color="error"
													@click="cancelTour"
												>
													<v-icon small
														>fa-times</v-icon
													>&nbsp;{{
														$t("buttons.cancel")
													}}
												</v-btn>
											</v-layout>
											<v-layout row wrap>
												<InputField
													v-if="!tour.cancelled"
													:label="
														$t('fields.tripStatus')
													"
													:value="
														$t('labels.confirmed')
													"
													readonly
												></InputField>
												<InputField
													v-if="tour.cancelled"
													:label="
														$t('fields.tripStatus')
													"
													:value="
														$t('labels.cancelled')
													"
													readonly
												></InputField>
											</v-layout>
										</v-flex>
										<v-flex xs12>
											<DropdownMultiple
												v-model="tour.guides"
												:ajax="true"
												:data="'users-guides'"
												:error="tourValidation.guides"
												:label="$t('fields.guides')"
												:readonly="
													$myStore.state.user
														.user_role_id == 2
												"
											></DropdownMultiple>
										</v-flex>
										<v-flex xs12>
											<TextArea
												v-model="tour.notes"
												:error="tourValidation.notes"
												:label="$t('fields.guideNotes')"
												:readonly="
													$myStore.state.user
														.user_role_id == 2 ||
														$myStore.state.user
															.user_role_id == 4
												"
											/>
										</v-flex>
										<v-flex v-if="tour.id != 0" xs12>
											<div
												v-if="tour.services.length != 0"
												class="services-list"
											>
												<div
													class="services-list-inner"
												>
													<div
														class="services-list-title"
													>
														{{
															$t(
																"labels.thirdPartyServices"
															)
														}}:
													</div>
													<div
														v-for="(service,
														key) in tour.services"
														:key="key"
														class="services-list-item"
													>
														{{
															service
																.supplier_service
																.subject.name
														}},
														{{
															service
																.supplier_service
																.service_type
																.name
														}},
														{{
															service
																.supplier_service
																.service_name
														}}
													</div>
												</div>
											</div>
										</v-flex>
										<v-flex xs12>
											<UploadMultiple
												v-model="tour.documents"
												:label="$t('fields.documents')"
												:readonly="
													$myStore.state.user
														.user_role_id == 2 ||
														$myStore.state.user
															.user_role_id == 4
												"
											/>
										</v-flex>
									</v-flex>
									<v-flex v-if="tour.id != 0" xs12>
										<v-layout row wrap>
											<v-spacer></v-spacer>
											<v-btn
												color="success"
												@click="pdfClick"
											>
												<v-icon small
													>fa-file-pdf </v-icon
												>&nbsp;{{
													$t(
														"buttons.saveAndBookingPdf"
													)
												}}
											</v-btn>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-tab-item>
							<v-tab-item
								v-if="
									tour.id != 0 &&
										$myStore.state.user.user_role_id != 2 &&
										$myStore.state.user.user_role_id != 4
								"
							>
								<v-layout pt-3 row wrap>
									<v-flex xs12>
										<v-btn
											color="success"
											@click="addGroupClick"
										>
											<v-icon small>fa-plus</v-icon
											>&nbsp;{{ $t("buttons.addGroup") }}
										</v-btn>
									</v-flex>
									<v-flex
										v-for="(group, groupKey) in tour.groups"
										:key="groupKey"
										mt-3
										xs12
									>
										<v-sheet
											class="d-flex pa-3 group-sheet"
											color="grey lighten-3"
										>
											<v-layout row wrap>
												<v-flex md4 xs12>
													<v-layout row wrap>
														<v-flex right xs12>
															<template
																v-if="
																	group.guests
																		.length <
																		maxGuestsPerGroup
																"
															>
																<v-btn
																	class="ma-1 ml-2 pl-2 pr-2"
																	color="success"
																	@click="
																		addExistingGuestClick(
																			groupKey
																		)
																	"
																>
																	<v-icon
																		small
																		>fa-user-plus </v-icon
																	>&nbsp;{{
																		$t(
																			"buttons.addExistingGuest"
																		)
																	}}
																</v-btn>
																<v-btn
																	class="ma-1 pl-2 pr-2"
																	color="success"
																	@click="
																		addNewGuestsClick(
																			groupKey
																		)
																	"
																>
																	<v-icon
																		small
																		>fa-user-plus </v-icon
																	>&nbsp;{{
																		$t(
																			"buttons.addNewGuests"
																		)
																	}}
																</v-btn>
															</template>
															<v-btn
																v-if="
																	group.guests
																		.length >
																		0
																"
																class="ma-1 pl-2 pr-2"
																color="success"
																@click="
																	sendBookingForm(
																		group
																	)
																"
															>
																<v-icon small
																	>fa-paper-plane </v-icon
																>&nbsp;{{
																	$t(
																		"buttons.sendBookingForm"
																	)
																}}
															</v-btn>
														</v-flex>
														<v-flex pa-2 xs12>
															<div
																class="guests-table-container"
															>
																<table
																	class="guests-table"
																>
																	<tr
																		v-for="(guest,
																		guestKey) in group.guests"
																		:key="
																			guestKey
																		"
																	>
																		<td>
																			<v-tooltip
																				bottom
																			>
																				<v-icon
																					slot="activator"
																					small
																					@click="
																						openGuest(
																							guest
																								.person
																								.id
																						)
																					"
																				>
																					fa-user
																				</v-icon>
																				<span
																					>{{
																						$t(
																							"tooltips.viewGuest"
																						)
																					}}</span
																				>
																			</v-tooltip>
																			&nbsp;
																			{{
																				guest
																					.person
																					.first_name
																			}}
																			{{
																				guest
																					.person
																					.last_name
																			}}
																		</td>
																		<td>
																			<CurrencyField
																				v-model="
																					guest.price
																				"
																				:simple="
																					true
																				"
																				@change.native="
																					guestFinancialsChange(
																						guest
																					)
																				"
																			></CurrencyField>
																		</td>
																		<td
																			class="guests-table-actions-column"
																		>
																			<v-tooltip
																				v-if="
																					guest.booking_form_sent
																				"
																				bottom
																			>
																				<v-icon
																					slot="activator"
																					small
																					@click="
																						resendBookingForm(
																							guest
																						)
																					"
																				>
																					fa-envelope </v-icon
																				>&nbsp;
																				<span
																					>{{
																						$t(
																							"tooltips.sendBookingForm"
																						)
																					}}</span
																				> </v-tooltip
																			>&nbsp;
																			<v-tooltip
																				bottom
																			>
																				<v-icon
																					slot="activator"
																					small
																					@click="
																						removeGuestClick(
																							groupKey,
																							guestKey,
																							guest.id
																						)
																					"
																				>
																					fa-trash
																				</v-icon>
																				<span
																					>{{
																						$t(
																							"tooltips.removeGuest"
																						)
																					}}</span
																				>
																			</v-tooltip>
																		</td>
																	</tr>
																	<tr>
																		<td
																			class="text-xs-right"
																		>
																			{{
																				$t(
																					"fields.total"
																				)
																			}}:
																		</td>
																		<td>
																			<CurrencyField
																				v-model="
																					groupTotals[
																						group
																							.id
																					]
																				"
																				:readonly="
																					true
																				"
																				:simple="
																					true
																				"
																			></CurrencyField>
																		</td>
																		<td></td>
																	</tr>
																</table>
															</div>
														</v-flex>

														<v-flex pa-2 pb-0 xs12>
															<v-radio-group
																v-model="
																	group.billing_type
																"
																hide-details
																row
															>
																<template
																	slot="label"
																	>{{
																		$t(
																			"labels.billing"
																		)
																	}}:
																</template>
																<v-radio
																	:label="
																		$t(
																			'labels.person'
																		)
																	"
																	:value="
																		'people'
																	"
																	@click.native="
																		billingTypeChange(
																			groupKey
																		)
																	"
																></v-radio>
																<v-radio
																	:label="
																		$t(
																			'labels.company'
																		)
																	"
																	:value="
																		'companies'
																	"
																	@click.native="
																		billingTypeChange(
																			groupKey
																		)
																	"
																></v-radio>
															</v-radio-group>
														</v-flex>
														<v-flex
															v-show="
																group.billing_type ==
																	'people'
															"
															xs12
														>
															<Dropdown
																v-model="
																	group.subject_id
																"
																:ajax="true"
																:data="
																	'subjects-people-buyers'
																"
																:simple="true"
																@changes="
																	subjectIdChange(
																		groupKey
																	)
																"
															></Dropdown>
														</v-flex>
														<v-flex
															v-show="
																group.billing_type ==
																	'companies'
															"
															xs12
														>
															<Dropdown
																v-model="
																	group.subject_id
																"
																:ajax="true"
																:data="
																	'subjects-companies-buyers'
																"
																:simple="true"
																@changes="
																	subjectIdChange(
																		groupKey
																	)
																"
															></Dropdown>
														</v-flex>
														<v-flex pl-2 pt-2 xs12>
															<template
																v-if="
																	prepaids[
																		group
																			.subject_id
																	] !==
																		undefined
																"
															>
																<span
																	v-if="
																		prepaids[
																			group
																				.subject_id
																		]
																			.amount !=
																			0
																	"
																>
																	{{
																		$t(
																			"labels.prepaidAmount"
																		)
																	}}:
																	{{
																		prepaids[
																			group
																				.subject_id
																		]
																			.amount_display
																	}}
																</span>
															</template>
														</v-flex>
													</v-layout>
												</v-flex>
												<v-flex md8 xs12>
													<v-layout row wrap>
														<v-flex xs12>
															<v-layout row wrap>
																<v-flex
																	style="max-width: 273px;"
																>
																	<Dropdown
																		v-model="
																			group.payment_account_id
																		"
																		:ajax="
																			true
																		"
																		:data="
																			'payment-accounts'
																		"
																		:label="
																			$t(
																				'fields.paymentAccount'
																			)
																		"
																		@changes="
																			paymentAccountChange(
																				groupKey
																			)
																		"
																	></Dropdown>
																</v-flex>
																<v-spacer></v-spacer>
																<v-btn
																	v-if="
																		!group.cash_flow_calculated
																	"
																	color="success"
																	@click="
																		calculateClick(
																			groupKey
																		)
																	"
																>
																	<v-icon
																		small
																		>fa-calculator</v-icon
																	>&nbsp;
																	{{
																		$t(
																			"buttons.calculate"
																		)
																	}}
																</v-btn>
																<v-btn
																	v-if="
																		group.cash_flow_calculated
																	"
																	color="success"
																	@click="
																		calculateClick(
																			groupKey
																		)
																	"
																>
																	<v-icon
																		small
																		>fa-calculator</v-icon
																	>&nbsp;
																	{{
																		$t(
																			"buttons.recalculate"
																		)
																	}}
																</v-btn>
																<v-btn
																	v-if="
																		group.offer_id ==
																			null &&
																			group.cash_flow_calculated &&
																			group.subject_id !=
																				null &&
																			group.payment_account_id !=
																				null
																	"
																	color="success"
																	@click="
																		createOfferClick(
																			groupKey
																		)
																	"
																>
																	<v-icon
																		small
																		>fa-file-invoice-dollar</v-icon
																	>&nbsp;
																	{{
																		$t(
																			"buttons.createOffer"
																		)
																	}}
																</v-btn>
																<v-btn
																	v-if="
																		group.offer_id !=
																			null
																	"
																	color="success"
																	@click="
																		openOfferClick(
																			groupKey
																		)
																	"
																>
																	<v-icon
																		small
																		>fa-file-invoice-dollar</v-icon
																	>&nbsp;
																	{{
																		$t(
																			"buttons.openOffer"
																		)
																	}}
																</v-btn>
																<v-btn
																	v-if="
																		group.invoice_id ==
																			null &&
																			group.cash_flow_calculated &&
																			group.subject_id !=
																				null &&
																			group.payment_account_id !=
																				null
																	"
																	color="success"
																	@click="
																		createInvoiceClick(
																			groupKey
																		)
																	"
																>
																	<v-icon
																		small
																		>fa-file-invoice-dollar</v-icon
																	>&nbsp;
																	{{
																		$t(
																			"buttons.createInvoice"
																		)
																	}}
																</v-btn>
																<v-btn
																	v-if="
																		group.invoice_id !=
																			null
																	"
																	color="success"
																	@click="
																		openInvoiceClick(
																			groupKey
																		)
																	"
																>
																	<v-icon
																		small
																		>fa-file-invoice-dollar</v-icon
																	>&nbsp;
																	{{
																		$t(
																			"buttons.openInvoice"
																		)
																	}}
																</v-btn>
																<v-btn
																	v-if="
																		group.invoice_id !=
																			null
																	"
																	color="success"
																	@click="
																		addPaymentClick(
																			groupKey
																		)
																	"
																>
																	<v-icon
																		small
																		>fa-money-bill-alt</v-icon
																	>&nbsp;
																	{{
																		$t(
																			"buttons.addPayment"
																		)
																	}}
																</v-btn>
																<v-btn
																	color="error"
																	@click="
																		removeGroupClick(
																			groupKey,
																			group.id
																		)
																	"
																>
																	<v-icon
																		small
																		>fa-trash</v-icon
																	>&nbsp;
																	{{
																		$t(
																			"buttons.deleteGroup"
																		)
																	}}
																</v-btn>
															</v-layout>
														</v-flex>
														<v-flex
															class="payments-table-container-wrapper"
															pa-2
															xs12
														>
															<div
																class="payments-table-container"
															>
																<table
																	class="payments-table"
																>
																	<tr>
																		<td>
																			{{
																				$t(
																					"labels.amount"
																				)
																			}}
																		</td>
																		<td>
																			{{
																				$t(
																					"labels.dueDate"
																				)
																			}}
																		</td>
																		<td>
																			{{
																				$t(
																					"labels.amountPaid"
																				)
																			}}
																		</td>
																		<td>
																			{{
																				$t(
																					"labels.notes"
																				)
																			}}
																		</td>
																	</tr>
																	<tr>
																		<td>
																			<CurrencyField
																				v-model="
																					group.deposit_amount
																				"
																				:class="{
																					'calculation-failed':
																						group.deposit_amount +
																							group.balance_amount !=
																						groupTotals[
																							group
																								.id
																						]
																				}"
																				:simple="
																					true
																				"
																				@change.native="
																					groupFinancialsChange(
																						groupKey,
																						false,
																						true
																					)
																				"
																			></CurrencyField>
																		</td>
																		<td>
																			<DatePicker
																				v-model="
																					group.deposit_due_date
																				"
																				:simple="
																					true
																				"
																				@changes="
																					groupFinancialsChange(
																						groupKey,
																						true
																					)
																				"
																			></DatePicker>
																		</td>
																		<td>
																			<CurrencyField
																				v-model="
																					group.deposit_paid
																				"
																				:readonly="
																					true
																				"
																				:simple="
																					true
																				"
																			></CurrencyField>
																		</td>
																		<td>
																			<InputField
																				v-model="
																					group.deposit_notes
																				"
																				:simple="
																					true
																				"
																				@change.native="
																					groupFinancialsChange(
																						groupKey
																					)
																				"
																			></InputField>
																		</td>
																	</tr>
																	<tr>
																		<td>
																			<CurrencyField
																				v-model="
																					group.balance_amount
																				"
																				:class="{
																					'calculation-failed':
																						group.deposit_amount +
																							group.balance_amount !=
																						groupTotals[
																							group
																								.id
																						]
																				}"
																				:simple="
																					true
																				"
																				@change.native="
																					groupFinancialsChange(
																						groupKey,
																						false,
																						true
																					)
																				"
																			></CurrencyField>
																		</td>
																		<td>
																			<DatePicker
																				v-model="
																					group.balance_due_date
																				"
																				:simple="
																					true
																				"
																				@changes="
																					groupFinancialsChange(
																						groupKey,
																						true
																					)
																				"
																			></DatePicker>
																		</td>
																		<td>
																			<CurrencyField
																				v-model="
																					group.balance_paid
																				"
																				:readonly="
																					true
																				"
																				:simple="
																					true
																				"
																			></CurrencyField>
																		</td>
																		<td>
																			<InputField
																				v-model="
																					group.balance_notes
																				"
																				:simple="
																					true
																				"
																				@change.native="
																					groupFinancialsChange(
																						groupKey
																					)
																				"
																			></InputField>
																		</td>
																	</tr>
																</table>
															</div>
														</v-flex>
														<v-flex pa-2 xs12>
															<v-layout row wrap>
																<v-flex
																	md6
																	xs12
																>
																	<UploadMultiple
																		v-model="
																			group.documents
																		"
																		:label="
																			$t(
																				'fields.documents'
																			)
																		"
																		@changes="
																			documentsChange(
																				groupKey
																			)
																		"
																	/>
																</v-flex>
																<v-flex
																	md6
																	xs12
																>
																	<TextArea
																		v-model="
																			group.notes
																		"
																		:label="
																			$t(
																				'fields.notes'
																			)
																		"
																		@change.native="
																			notesChange(
																				groupKey
																			)
																		"
																	/>
																</v-flex>
															</v-layout>
														</v-flex>
													</v-layout>
												</v-flex>
											</v-layout>
										</v-sheet>
									</v-flex>
								</v-layout>
								<v-layout pt-3 row wrap>
									<v-spacer></v-spacer>
									<v-flex class="mw300">
										<table class="summary-table">
											<tr>
												<td>
													{{
														$t("labels.guestsPaid")
													}}:
												</td>
												<td>
													{{
														$formatMoney(totalPaid)
													}}
													EUR
												</td>
											</tr>

											<tr>
												<td>
													{{
														$t(
															"labels.totalBalance"
														)
													}}:
												</td>
												<td>
													{{
														$formatMoney(
															totalBalance
														)
													}}
													EUR
												</td>
											</tr>
										</table>
									</v-flex>
								</v-layout>
								<v-layout pb-5 pt-3 row wrap>
									<v-flex xs12>
										<v-btn
											v-if="
												$myStore.state.user
													.user_role_id != 4
											"
											color="success"
											@click="addGroupClick"
										>
											<v-icon small>fa-plus</v-icon
											>&nbsp;{{ $t("buttons.addGroup") }}
										</v-btn>
									</v-flex>
								</v-layout>
							</v-tab-item>
							<v-tab-item
								v-if="
									tour.id != 0 &&
										$myStore.state.user.user_role_id != 2
								"
							>
								<v-layout pt-3 row wrap>
									<v-flex xs12>
										<v-btn
											v-if="
												$myStore.state.user
													.user_role_id != 4
											"
											color="success"
											@click="addServiceClick"
										>
											<v-icon small>fa-plus</v-icon
											>&nbsp;{{
												$t("buttons.addSupplierService")
											}}
										</v-btn>
									</v-flex>
								</v-layout>
								<v-layout pt-3 row wrap>
									<v-flex xs12>
										<table class="services-table">
											<tr>
												<td>
													{{
														$t(
															"fields.supplierName"
														)
													}}
												</td>
												<td>
													{{
														$t("fields.serviceType")
													}}
												</td>
												<td>
													{{
														$t("fields.serviceName")
													}}
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													{{ $t("fields.price") }}
												</td>
												<td>
													{{ $t("fields.quantity") }}
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													{{ $t("fields.amount") }}
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													{{ $t("fields.dueDate") }}
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													{{
														$t("fields.paidAmount")
													}}
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													{{ $t("fields.datePaid") }}
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													{{ $t("fields.account") }}
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													{{
														$t(
															"fields.transactionId"
														)
													}}
												</td>
												<td>
													{{ $t("fields.notes") }}
												</td>
												<td style="width: 90px;"></td>
											</tr>
											<tr
												v-for="(service,
												serviceIndex) in this.tour
													.services"
												:key="serviceIndex"
											>
												<td>
													{{
														service.supplier_service
															.subject.name
													}}
												</td>
												<td>
													{{
														service.supplier_service
															.service_type.name
													}}
												</td>
												<td>
													{{
														service.supplier_service
															.service_name
													}}
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													<CurrencyField
														v-model="service.price"
														:readonly="
															service.cancelled ||
																$myStore.state
																	.user
																	.user_role_id ==
																	4
														"
														:simple="true"
														@change.native="
															serviceFinancialsChange(
																serviceIndex
															)
														"
													></CurrencyField>
												</td>
												<td>
													<InputField
														v-model="
															service.quantity
														"
														:mask="'###'"
														:readonly="
															service.cancelled ||
																$myStore.state
																	.user
																	.user_role_id ==
																	4
														"
														:simple="true"
														@change.native="
															serviceFinancialsChange(
																serviceIndex
															)
														"
													></InputField>
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													<CurrencyField
														v-model="service.amount"
														:readonly="true"
														:simple="true"
													></CurrencyField>
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													<DatePicker
														v-model="
															service.due_date
														"
														:readonly="
															service.cancelled ||
																$myStore.state
																	.user
																	.user_role_id ==
																	4
														"
														:simple="true"
														@changes="
															serviceDueDateChange(
																serviceIndex
															)
														"
													></DatePicker>
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													<CurrencyField
														v-model="
															service.paid_amount
														"
														:readonly="true"
														:simple="true"
													></CurrencyField>
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													<DatePicker
														v-model="
															service.paid_date
														"
														:readonly="
															service.paid_date ==
																null ||
																service.cancelled ||
																$myStore.state
																	.user
																	.user_role_id ==
																	4
														"
														:simple="true"
														@changes="
															servicePaidDateChange(
																serviceIndex
															)
														"
													></DatePicker>
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													<Dropdown
														v-model="
															service.payment_account_id
														"
														:ajax="true"
														:data="
															'payment-accounts'
														"
														:readonly="
															service.cancelled ||
																$myStore.state
																	.user
																	.user_role_id ==
																	4
														"
														:simple="true"
														@changes="
															serviceAccountChange(
																serviceIndex
															)
														"
													></Dropdown>
												</td>
												<td
													v-if="
														$myStore.state.user
															.user_role_id != 4
													"
												>
													{{ service.transaction_id }}
												</td>
												<td>
													<InputField
														v-model="service.notes"
														:readonly="
															service.cancelled ||
																$myStore.state
																	.user
																	.user_role_id ==
																	4
														"
														:simple="true"
														@change.native="
															serviceNotesChange(
																serviceIndex
															)
														"
													></InputField>
												</td>
												<td>
													<v-tooltip
														v-if="
															service.paid_date ==
																null &&
																!service.cancelled
														"
														bottom
													>
														<v-btn
															slot="activator"
															class="ma-0"
															icon
															@click="
																serviceMakePayment(
																	serviceIndex
																)
															"
														>
															<v-icon small
																>fa-money-bill-alt</v-icon
															>
														</v-btn>
														<span>{{
															$t(
																"tooltips.recordPayment"
															)
														}}</span>
													</v-tooltip>

													<v-tooltip
														v-if="
															!service.cancelled
														"
														bottom
													>
														<v-btn
															v-if="
																$myStore.state
																	.user
																	.user_role_id !=
																	4
															"
															slot="activator"
															class="ma-0"
															icon
															@click="
																removeServiceClick(
																	serviceIndex,
																	service.id
																)
															"
														>
															<v-icon small
																>fa-trash</v-icon
															>
														</v-btn>
														<span>{{
															$t(
																"tooltips.deleteSupplierService"
															)
														}}</span>
													</v-tooltip>
												</td>
											</tr>
											<template
												v-if="tour.services.length == 0"
											>
												<tr>
													<td colspan="13">&nbsp;</td>
												</tr>
												<tr>
													<td colspan="13">
														{{
															$t(
																"labels.tourNoServices"
															)
														}}
													</td>
												</tr>
											</template>
										</table>
									</v-flex>
								</v-layout>
							</v-tab-item>
							<v-tab-item
								v-if="
									tour.id != 0 &&
										$myStore.state.user.user_role_id != 2
								"
							>
								<table class="summary-table mt-5">
									<tr>
										<td>{{ $t("labels.totalIncome") }}:</td>
										<td>
											{{ $formatMoney(totalBalance) }} EUR
										</td>
									</tr>
									<tr>
										<td>{{ $t("labels.totalCost") }}:</td>
										<td>
											{{ $formatMoney(totalCost) }} EUR
										</td>
									</tr>
									<tr>
										<td>
											{{ $t("labels.totalGrossProfit") }}:
										</td>
										<td>
											{{ $formatMoney(totalGrossProfit) }}
											EUR
										</td>
									</tr>
									<tr>
										<td>
											{{ $t("labels.totalGrossProfit") }}
											%:
										</td>
										<td>
											{{ totalGrossProfitPercentage }} %
										</td>
									</tr>
									<tr>
										<td colspan="2">&nbsp;</td>
									</tr>
									<tr>
										<td>{{ $t("labels.guestsPaid") }}:</td>
										<td>
											{{ $formatMoney(totalPaid) }} EUR
										</td>
									</tr>
									<tr>
										<td>
											{{ $t("labels.totalBalanceDue") }}:
										</td>
										<td>
											{{ $formatMoney(totalBalanceDue) }}
											EUR
										</td>
									</tr>
								</table>
							</v-tab-item>
						</v-tabs>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField";
import Dropdown from "./trinkets/Dropdown";
import DropdownMultiple from "./trinkets/DropdownMultiple";
import DatePicker from "./trinkets/DatePicker";
import TextArea from "./trinkets/TextArea";
import CurrencyField from "./trinkets/CurrencyField";
import UploadMultiple from "./trinkets/UploadMultiple";
import Payment from "./modals/Payment";
import Email from "./modals/Email";
import PersonModal from "./modals/PersonModal";

export default {
	name: "Tour",
	components: {
		InputField,
		Dropdown,
		DropdownMultiple,
		DatePicker,
		TextArea,
		CurrencyField,
		UploadMultiple,
		Payment,
		Email,
		PersonModal
	},
	props: {
		id: Number,
		action: String
	},
	data: function() {
		return {
			tabId: 0,
			initialLoad: false,
			tour: {
				id: this.$route.params.id,
				name: "",
				tour_category_id: null,
				destination_id: null,
				start_date: null,
				end_date: null,
				meeting_point: "",
				departure: "",
				services: [],
				cancelled: false,
				guides: [],
				notes: "",
				documents: [],
				groups: []
			},
			tourValidation: {
				id: "",
				name: "",
				tour_category_id: "",
				destination_id: "",
				start_date: "",
				end_date: "",
				meeting_point: "",
				departure: "",
				services: "",
				cancelled: "",
				guides: "",
				notes: "",
				documents: "",
				groups: ""
			},
			groupTemplate: {
				id: 0,
				billing_type: "persons",
				documents: [],
				notes: "",
				cash_flow_calculated: 0,
				deposit_amount: 0,
				deposit_due_date: null,
				deposit_paid: 0,
				balance_amount: 0,
				balance_due_date: null,
				balance_paid: 0,
				deposit_notes: "",
				balance_notes: "",
				transaction_id: "",
				transaction_sequence: "",
				payment_account_id: null,
				subject_id: null,
				invoice_id: null,
				guests: []
			},
			guestModalShow: false,
			guest: {
				person_id: null,
				tour_group_id: null,
				tour_group_key: null
			},
			guestValidation: {
				person_id: "",
				tour_group_id: ""
			},
			paymentModal: {
				show: false,
				id: null,
				invoice_id: null
			},
			sendTourGroupModalId: null,
			sendTourGroupModalShow: false,
			sendTourGroupGuestModalId: null,
			sendTourGroupGuestModalShow: false,
			personModalShow: false,
			personModalMaxGuests: null,
			personModalTourGroupId: null,
			personModalTourGroupIndex: null,
			prepaids: [],
			maxGuestsPerGroup: 15,
			trySaveTimer: null
		};
	},
	computed: {
		groupTotals() {
			let totals = {};
			for (let group of this.tour.groups) {
				let total = 0;
				for (let guest of group.guests) {
					total += guest.price;
				}
				totals[group.id] = total;
			}
			return totals;
		},
		formsSent() {
			let term = true;
			for (let group of this.tour.groups) {
				for (let guest of group.guests) {
					if (!guest.booking_form_sent) {
						term = false;
					}
				}
			}
			return term;
		},
		showDepositsPaid() {
			return this.tour.groups.length > 0;
		},
		showBalancesPaid() {
			return this.tour.groups.length > 0;
		},
		showSuppliersPaid() {
			return this.tour.services.length > 0;
		},
		depositsPaid() {
			let term = true;
			for (let group of this.tour.groups) {
				if (group.deposit_paid != group.deposit_amount) {
					term = false;
				}
			}
			return term;
		},
		balancesPaid() {
			let term = true;
			for (let group of this.tour.groups) {
				if (group.balance_paid != group.balance_amount) {
					term = false;
				}
			}
			return term;
		},
		servicesPaid() {
			let term = true;
			for (let service of this.tour.services) {
				if (service.paid_date == null) {
					term = false;
				}
			}
			return term;
		},
		totalPaid() {
			let total = 0;
			for (let group of this.tour.groups) {
				total += group.deposit_paid + group.balance_paid;
			}
			return total;
		},
		totalBalance() {
			let total = 0;
			for (let group of this.tour.groups) {
				total += group.deposit_amount + group.balance_amount;
			}
			return total;
		},
		totalCost() {
			let total = 0;
			for (let service of this.tour.services) {
				total += service.price * service.quantity;
			}
			return total;
		},
		totalGrossProfit() {
			return this.totalBalance - this.totalCost;
		},
		totalBalanceDue() {
			return this.totalBalance - this.totalPaid;
		},
		totalGrossProfitPercentage() {
			if (this.totalBalance == 0) {
				return 0;
			}
			return (
				Math.round(
					(this.totalGrossProfit / this.totalBalance) * 10000
				) / 100
			);
		},
		formsSentTooltip() {
			return this.formsSent
				? this.$t("labels.formsSent")
				: this.$t("labels.formsNotSent");
		},
		depositsPaidTooltip() {
			return this.depositsPaid
				? this.$t("labels.depositsPaid")
				: this.$t("labels.depositsNotPaid");
		},
		balancesPaidTooltip() {
			return this.balancesPaid
				? this.$t("labels.balancesPaid")
				: this.$t("labels.balancesNotPaid");
		},
		servicesPaidTooltip() {
			return this.servicesPaid
				? this.$t("labels.servicesPaid")
				: this.$t("labels.servicesNotPaid");
		},
		guestsCount() {
			let count = 0;
			for (let group of this.tour.groups) {
				count += group.guests.length;
			}
			return count;
		}
	},
	watch: {
		"tour.name": {
			handler: function() {
				if (this.initialLoad) {
					this.changesHappened = true;
					if (this.tour.id != 0) {
						this.trySave();
					}
				}
			},
			deep: true
		},
		"tour.guides": {
			handler: function() {
				if (this.initialLoad) {
					this.changesHappened = true;
					if (this.tour.id != 0) {
						this.trySave();
					}
				}
			},
			deep: true
		},
		"tour.tour_category_id": {
			handler: function() {
				if (this.initialLoad) {
					this.changesHappened = true;
					if (this.tour.id != 0) {
						this.trySave();
					}
				}
			},
			deep: true
		},
		"tour.notes": {
			handler: function() {
				if (this.initialLoad) {
					this.changesHappened = true;
					if (this.tour.id != 0) {
						this.trySave();
					}
				}
			},
			deep: true
		},
		"tour.destination_id": {
			handler: function() {
				if (this.initialLoad) {
					this.changesHappened = true;
					if (this.tour.id != 0) {
						this.trySave();
					}
				}
			},
			deep: true
		},
		"tour.start_date": {
			handler: function() {
				if (this.initialLoad) {
					this.changesHappened = true;
					if (this.tour.id != 0) {
						this.trySave();
					} else {
						if (this.tour.end_date == null) {
							this.tour.end_date = this.tour.start_date;
						}
					}
				}
			},
			deep: true
		},
		"tour.end_date": {
			handler: function() {
				if (this.initialLoad) {
					this.changesHappened = true;
					if (this.tour.id != 0) {
						this.trySave();
					}
				}
			},
			deep: true
		},
		"tour.documents": {
			handler: function() {
				if (this.initialLoad) {
					this.changesHappened = true;
					if (this.tour.id != 0) {
						this.trySave();
					}
				}
			},
			deep: true
		},
		"tour.meeting_point": {
			handler: function() {
				if (this.initialLoad) {
					this.changesHappened = true;
					if (this.tour.id != 0) {
						this.trySave();
					}
				}
			},
			deep: true
		},
		"tour.departure": {
			handler: function() {
				if (this.initialLoad) {
					this.changesHappened = true;
					if (this.tour.id != 0) {
						this.trySave();
					}
				}
			},
			deep: true
		}
	},
	methods: {
		trySave() {
			if (this.trySaveTimer !== null) clearTimeout(this.trySaveTimer);
			this.trySaveTimer = setTimeout(()=>{
				this.saveAction(false, false);
				this.trySaveTimer = null;
			}, 1000);
		},
		createOfferClick(groupKey) {
			let vm = this;
			let payload = {
				tour_group_id: this.tour.groups[groupKey].id,
				payment_account_id: this.tour.groups[groupKey]
					.payment_account_id
			};
			this.$APICall("post", "offers", payload, (data, success) => {
				if (success) {
					this.tour.groups[groupKey].offer_id = data.id;
					window.open(data.pdf_link, "_blank");
				} else {
					vm.$alert(vm.$t("alerts.basicError"));
				}
			});
		},
		openOfferClick(groupKey) {
			let vm = this;
			this.$APICall(
				"get",
				"offers/" + this.tour.groups[groupKey].offer_id,
				{},
				(data, success) => {
					if (success) {
						window.open(data.pdf_link, "_blank");
					} else {
						vm.$alert(vm.$t("alerts.basicError"));
					}
				}
			);
		},
		personModalCallback() {
			this.personModalShow = false;
			this.loadTour();
		},
		sendTourGroupModalCallback() {
			this.sendTourGroupModalShow = false;
			this.loadTour();
		},
		sendTourGroupGuestModalCallback() {
			this.sendTourGroupGuestModalShow = false;
			this.loadTour();
		},
		guestFinancialsChange(guest) {
			let vm = this;
			this.$APICall(
				"put",
				"tour-groups-guests/" + guest.id,
				guest,
				(data, success) => {
					if (!success) {
						vm.$alert(vm.$t("alerts.basicError"));
					}
				}
			);
		},
		openGuest(id) {
			let routeData = this.$router.resolve("/people/" + id);
			window.open(routeData.href, "_blank");
		},
		pdfClick() {
			this.saveAction(true);
		},
		cancelTour() {
			let vm = this;
			this.$verify(this.$t("alerts.tourCancelQuestion"), result => {
				if (result) {
					vm.$APICall(
						"post",
						"tours/cancel/" + vm.tour.id,
						{},
						(data, success) => {
							if (success) {
								if (data.invoices.length == 0) {
									vm.loadTour();
								} else {
									this.cancelInvoices(0, data.invoices);
								}
							} else {
								vm.$alert(vm.$t("alerts.basicError"));
							}
						}
					);
				}
			});
		},
		cancelInvoices(key, invoices) {
			let invoice = invoices[key];
			let vm = this;
			let message = this.$t("alerts.tourInvoiceCancelQuestion");
			message = message.replace("%number%", invoice.number);
			message = message.replace("%amount%", invoice.display_amount);
			this.$verify(message, result => {
				if (result) {
					vm.$APICall(
						"post",
						"tours/cancel-invoice/" + invoice.id,
						{},
						(data, success) => {
							if (success) {
								vm.continueInvoices(key, invoices);
							} else {
								vm.$alert(vm.$t("alerts.basicError"));
							}
						}
					);
				} else {
					this.continueInvoices(key, invoices);
				}
			});
		},
		continueInvoices(key, invoices) {
			key++;
			if (key == invoices.length) {
				this.loadTour();
			} else {
				this.cancelInvoices(key, invoices);
			}
		},
		resendBookingForm(guest) {
			let vm = this;
			this.sendTourGroupGuestModalId = guest.id;
			this.sendTourGroupGuestModalShow = true;
			// this.$verify(this.$t('alerts.bookingResend'), (result) => {
			// 	if (result) {
			// 		let vm = this;
			// 		this.$APICall('post', 'tours-groups-guests/send-booking-form/' + guest.id, {}, (data, success) => {
			// 			if (success) {
			// 				vm.$notify(vm.$t('alerts.bookingSent'));
			// 			} else {
			// 				vm.$alert(vm.$t('alerts.basicError'));
			// 			}
			// 		});
			// 	}
			// });
		},
		sendBookingForm(group) {
			this.sendTourGroupModalId = group.id;
			this.sendTourGroupModalShow = true;
		},
		removeServiceClick(serviceKey, serviceId) {
			let vm = this;
			this.$verify(this.$t("alerts.removalQuestion"), result => {
				if (result) {
					vm.$APICall(
						"delete",
						"tours-services/" + serviceId,
						vm.guest,
						(data, success) => {
							if (success) {
								vm.tour.services.splice(serviceKey, 1);
							} else {
								vm.$alert(vm.$t("alerts.basicError"));
							}
						}
					);
				}
			});
		},
		serviceMakePayment(serviceKey) {
			let vm = this;
			this.$verify(this.$t("alerts.markAsPaidQuestionSingle"), result => {
				if (result) {
					let moment = require("moment");
					vm.tour.services[serviceKey].paid_date = moment().format(
						"YYYY-MM-DD"
					);
				}
			});
		},
		serviceFinancialsChange(serviceKey) {
			this.tour.services[serviceKey].amount =
				this.tour.services[serviceKey].price *
				this.tour.services[serviceKey].quantity;
			if (this.tour.services[serviceKey].paid_date != null) {
				this.tour.services[serviceKey].paid_amount = this.tour.services[
					serviceKey
				].amount;
			}
			let data = {
				price: this.tour.services[serviceKey].price,
				quantity: this.tour.services[serviceKey].quantity
			};
			this.serviceSave(serviceKey, data);
		},
		serviceAccountChange(serviceKey) {
			let data = {
				payment_account_id: this.tour.services[serviceKey]
					.payment_account_id
			};
			this.serviceSave(serviceKey, data);
		},
		serviceDueDateChange(serviceKey) {
			let data = {
				due_date: this.tour.services[serviceKey].due_date
			};
			this.serviceSave(serviceKey, data);
		},
		servicePaidDateChange(serviceKey) {
			if (this.tour.services[serviceKey].paid_date != null) {
				this.tour.services[serviceKey].paid_amount = this.tour.services[
					serviceKey
				].amount;
			} else {
				this.tour.services[serviceKey].paid_amount = 0;
			}
			let data = {
				paid_date: this.tour.services[serviceKey].paid_date
			};
			this.serviceSave(serviceKey, data);
		},
		serviceNotesChange(serviceKey) {
			let data = {
				notes: this.tour.services[serviceKey].notes
			};
			this.serviceSave(serviceKey, data);
		},
		serviceSave(serviceKey, data) {
			let serviceId = this.tour.services[serviceKey].id;
			let vm = this;
			vm.$APICall(
				"put",
				"tours-services/" + serviceId,
				data,
				(data, success) => {
					if (!success) {
						vm.$alert(vm.$t("alerts.basicError"));
					}
				}
			);
		},
		addServiceClick() {
			this.$dropdown(
				this.$t("labels.selectSupplierService"),
				null,
				"supplier-services-details",
				response => {
					if (response !== false && response !== null) {
						let vm = this;
						let data = {
							tour_id: this.tour.id,
							supplier_service_id: response
						};
						vm.$APICall(
							"post",
							"tours-services",
							data,
							(data, success) => {
								if (success) {
									let newService = JSON.parse(
										JSON.stringify(data)
									);
									this.tour.services.push(newService);
								} else {
									vm.$alert(vm.$t("alerts.basicError"));
								}
							}
						);
					}
				}
			);
		},
		removeGroupClick(groupKey, groupId) {
			let vm = this;
			this.$verify(this.$t("alerts.removalQuestionNoUndo"), result => {
				if (result) {
					vm.$APICall(
						"delete",
						"tour-groups/" + groupId,
						vm.guest,
						(data, success) => {
							if (success) {
								vm.tour.groups.splice(groupKey, 1);
							} else {
								if (data.internal_message == "invoice exists") {
									vm.$alert(
										vm.$t(
											"alerts.groupDeletionInvoiceExists"
										)
									);
								} else {
									vm.$alert(vm.$t("alerts.basicError"));
								}
							}
						}
					);
				}
			});
		},
		addPaymentClick(groupKey) {
			let invoiceId = this.tour.groups[groupKey].invoice_id;
			this.paymentModal.invoice_id = invoiceId;
			this.paymentModal.show = true;
		},
		paymentModalCallback() {
			this.paymentModal.show = false;
			this.loadTour();
		},
		documentsChange(groupKey) {
			let data = {
				documents: this.tour.groups[groupKey].documents
			};
			this.billingGroupSave(groupKey, data);
		},
		notesChange(groupKey) {
			let data = {
				notes: this.tour.groups[groupKey].notes
			};
			this.billingGroupSave(groupKey, data);
		},
		createInvoiceClick(groupKey) {
			let routeData = this.$router.resolve(
				"/invoices/" + this.tour.groups[groupKey].id + "/group"
			);
			window.open(routeData.href, "_blank");
		},
		openInvoiceClick(groupKey) {
			let routeData = this.$router.resolve(
				"/invoices/" + this.tour.groups[groupKey].invoice_id + "/edit"
			);
			window.open(routeData.href, "_blank");
		},
		calculateClick(groupKey) {
			if (this.tour.groups[groupKey].cash_flow_calculated) {
				var vm = this;
				this.$verify(this.$t("alerts.recalculate"), result => {
					if (result) {
						vm.calculateAction(groupKey);
					}
				});
			} else {
				this.calculateAction(groupKey);
			}
		},
		calculateAction(groupKey) {
			let amount = 0;
			for (let guest of this.tour.groups[groupKey].guests) {
				amount += guest.price;
			}
			let amountDeposit = (amount * 0.3).toFixed(2);
			if (
				this.tour.groups[groupKey].deposit_amount != 0 &&
				this.tour.groups[groupKey].deposit_paid != 0
			) {
				amountDeposit = this.tour.groups[groupKey].deposit_amount;
			}
			let amountBalance = amount - amountDeposit;

			let balanceDueDate = null;
			if (this.tour.start_date != null) {
				let moment = require("moment");
				let startDate = moment(this.tour.start_date);
				balanceDueDate = startDate.add(30, "days").format("YYYY-MM-DD");
			}

			this.tour.groups[groupKey].deposit_amount = amountDeposit;
			this.tour.groups[groupKey].balance_amount = amountBalance;
			this.tour.groups[groupKey].cash_flow_calculated = true;
			this.tour.groups[groupKey].balance_due_date = balanceDueDate;

			this.groupFinancialsChange(groupKey, false, true);
		},
		groupFinancialsChange(groupKey, testDates = false, offer = false) {
			let group = this.tour.groups[groupKey];

			if (testDates) {
				if (
					group.deposit_due_date != "" &&
					group.balance_due_date != ""
				) {
					if (group.deposit_due_date > group.balance_due_date) {
						this.$alert(this.$t("alerts.depositDueDateError"));
					}
				}
			}

			let data = {
				deposit_amount: group.deposit_amount,
				balance_amount: group.balance_amount,
				cash_flow_calculated: group.cash_flow_calculated,
				deposit_due_date: group.deposit_due_date,
				balance_due_date: group.balance_due_date,
				deposit_notes: group.deposit_notes,
				balance_notes: group.balance_notes
			};
			this.billingGroupSave(groupKey, data, offer);
		},
		paymentAccountChange(groupKey) {
			let data = {
				payment_account_id: this.tour.groups[groupKey]
					.payment_account_id
			};
			this.billingGroupSave(groupKey, data);
		},
		subjectIdChange(groupKey) {
			let data = {
				subject_id: this.tour.groups[groupKey].subject_id
			};
			this.billingGroupSave(groupKey, data);
		},
		billingTypeChange(groupKey) {
			this.tour.groups[groupKey].subject_id = null;
			let data = {
				billing_type: this.tour.groups[groupKey].billing_type,
				subject_id: null
			};
			this.billingGroupSave(groupKey, data);
		},
		billingGroupSave(groupKey, data, offer = false) {
			let groupId = this.tour.groups[groupKey].id;
			let vm = this;
			vm.$APICall(
				"put",
				"tours-groups/" + groupId,
				data,
				(data, success) => {
					if (!success) {
						vm.$alert(vm.$t("alerts.basicError"));
					} else {
						if (offer) {
							vm.tour.groups[groupKey].offer_id = null;
						}
					}
				}
			);
		},
		removeGuestClick(groupKey, guestKey, guestId) {
			let vm = this;
			this.$verify(this.$t("alerts.removalQuestion"), result => {
				if (result) {
					vm.$APICall(
						"delete",
						"tour-groups-guests/" + guestId,
						vm.guest,
						(data, success) => {
							if (success) {
								vm.tour.groups[groupKey].guests.splice(
									guestKey,
									1
								);
							} else {
								vm.$alert(vm.$t("alerts.basicError"));
							}
						}
					);
				}
			});
		},
		addExistingGuestClick(groupIndex) {
			this.guest.tour_group_key = groupIndex;
			this.guest.tour_group_id = this.tour.groups[groupIndex].id;
			this.openGuestModal();
		},
		addNewGuestsClick(groupIndex) {
			this.personModalTourGroupIndex = groupIndex;
			this.personModalTourGroupId = this.tour.groups[groupIndex].id;
			this.personModalMaxGuests =
				this.maxGuestsPerGroup -
				this.tour.groups[groupIndex].guests.length;
			this.personModalShow = true;
		},
		openGuestModal() {
			this.guest.person_id = null;
			this.guestModalShow = true;
		},
		closeGuestModal() {
			this.guest.tour_group_key = null;
			this.guest.tour_group_id = null;
			this.guest.person_id = null;
			this.guestModalShow = false;
		},
		cancelGuestModal() {
			this.closeGuestModal();
		},
		okGuestModal() {
			let success = true;

			if (this.guest.person_id == null) {
				success = false;
				this.guestValidation.person_id = this.$t("alerts.fieldError");
			} else {
				this.guestValidation.person_id = "";
			}

			if (success) {
				let vm = this;
				vm.$APICall(
					"post",
					"tour-groups-guests",
					vm.guest,
					(data, success) => {
						if (success) {
							vm.tour.groups[vm.guest.tour_group_key].guests.push(
								data
							);
							if (
								vm.tour.groups[vm.guest.tour_group_key].guests
									.length == 1
							) {
								vm.tour.groups[
									vm.guest.tour_group_key
								].billing_type = "people";
								vm.tour.groups[
									vm.guest.tour_group_key
								].subject_id = data.person.subject.id;
								let payload = {
									billing_type: "people",
									subject_id: data.person.subject.id
								};
								vm.billingGroupSave(
									vm.guest.tour_group_key,
									payload
								);
							}
						} else {
							if (data.internal_message == "duplicate") {
								vm.$alert(vm.$t("alerts.personOnTheList"));
							} else if (
								data.internal_message == "duplicate_tour"
							) {
								vm.$alert(vm.$t("alerts.personOnTheTour"));
							} else {
								vm.$alert(vm.$t("alerts.basicError"));
							}
						}
						this.closeGuestModal();
					}
				);
			}
		},
		addGroupClick() {
			let vm = this;
			this.$APICall(
				"post",
				"tours-groups",
				{ tour_id: this.tour.id },
				(data, success) => {
					if (success) {
						vm.tour.groups.push(data);
					} else {
						vm.$alert(vm.$t("alerts.basicError"));
					}
				}
			);
		},
		backClick() {
			this.$router.go(-1);
		},
		saveClick() {
			this.saveAction();
		},
		saveAction(openPdf = false, loader = true) {
			let success = true;

			if (this.tour.name == "") {
				success = false;
				this.tourValidation.name = this.$t("alerts.fieldError");
			} else {
				this.tourValidation.name = "";
			}

			if (this.tour.tour_category_id == null) {
				success = false;
				this.tourValidation.tour_category_id = this.$t(
					"alerts.fieldError"
				);
			} else {
				this.tourValidation.tour_category_id = "";
			}

			if (this.tour.destination_id == null) {
				success = false;
				this.tourValidation.destination_id = this.$t(
					"alerts.fieldError"
				);
			} else {
				this.tourValidation.destination_id = "";
			}

			if (this.tour.end_date != null) {
				if (this.tour.start_date != null) {
					if (this.tour.start_date > this.tour.end_date) {
						success = false;
						this.tourValidation.end_date = this.$t(
							"alerts.endDateError"
						);
					} else {
						this.tourValidation.end_date = "";
					}
				} else {
					this.tourValidation.end_date = "";
				}
			} else {
				this.tourValidation.end_date = "";
			}

			if (success) {
				let vm = this;
				let action = "post";
				let addition = "";
				if (vm.tour.id != 0) {
					action = "put";
					addition = "/" + vm.tour.id;
				}
				vm.$APICall(
					action,
					"tours" + addition,
					vm.tour,
					(data, success) => {
						if (success) {
							vm.changesHappened = false;
							if (vm.tour.id == 0) {
								vm.$notify(vm.$t("alerts.basicAdd"));
							} else {
								if (openPdf) {
									vm.$APICall(
										"get",
										"tours/pdf/" + this.tour.id,
										{},
										(data, success) => {
											window.open(data.pdf_link);
										}
									);
								}
							}
							if (vm.tour.id == 0) {
								vm.$triggerReload();
								this.$router.push("/tours/" + data.id);
							}
						} else {
							vm.$alert(vm.$t("alerts.basicError"));
						}
					},
					loader
				);
			}
		},
		loadTour() {
			let vm = this;
			this.$APICall(
				"get",
				"tours/" + this.tour.id,
				{},
				(data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data));
						vm.tour = usableData;
						let breadcrumbText =
							vm.tour.id +
							" - " +
							vm.tour.name +
							" - " +
							vm.tour.destination_display +
							" - " +
							vm.tour.category_display +
							" - " +
							vm.tour.start_date_display;
						this.$setSubMenu("");
						vm.$myStore.commit("setBreadcrumbs", [
							{
								text: vm.$t("modules.tours"),
								href: "/#/tours",
								disabled: false
							},
							{
								text: breadcrumbText,
								href: "/#/tours/" + vm.tour.id,
								disabled: true
							}
						]);
						vm.$nextTick(() => {
							vm.initialLoad = true;
						});
					} else {
						vm.$alert(vm.$t("alerts.basicError"));
					}
				}
			);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace("login");
		}
		let vm = this;
		this.$APICall(
			"get",
			"subjects/prepaid",
			{},
			(data, success) => {
				if (success) {
					vm.prepaids = data;
				} else {
					vm.$alert(vm.$t("alerts.basicError"));
				}
			},
			true
		);
		if (this.tour.id != 0) {
			this.loadTour();
		} else {
			this.$setSubMenu("");
			this.$myStore.commit("setBreadcrumbs", [
				{
					text: this.$t("modules.tours"),
					href: "/#/tours",
					disabled: false
				},
				{
					text: this.$t("modules.newTour"),
					href: "/#/tours/0",
					disabled: true
				}
			]);
			this.initialLoad = true;
		}
		this.$onTourReload(() => {
			this.loadTour();
		});
	},
	beforeRouteLeave(to, from, next) {
		if (this.changesHappened) {
			this.$verify(this.$t("alerts.leaveQuestion"), result => {
				next(result);
			});
		} else {
			next(true);
		}
	}
};
</script>

<style scoped>
.mw300 {
	max-width: 300px;
}

.summary-table {
	width: 100%;
	max-width: 300px;
}

.summary-table td {
	text-align: right;
}

.summary-table td:first-child {
	font-weight: bold;
}

.services-list {
	padding: 8px;
}

.services-list-inner {
	background-color: #eeeeee;
	padding: 8px;
	white-space: nowrap;
	overflow: auto;
}

.services-list-title {
	font-weight: bold;
}

.services-list-item {
	padding-left: 8px;
}

.guests-table-container {
	margin-top: 20px;
	width: 100%;
	height: 180px;
	overflow: auto;
	background: white;
}

.guests-table {
	width: 100%;
	border-collapse: collapse;
}

.guests-table tr:hover {
	background: #fafafa;
}

.guests-table td {
	height: 50px;
	border-bottom: 1px grey solid;
}

.guests-table td:first-child {
	padding-left: 10px;
}

.guests-table-actions-column {
	width: 50px;
}

.payments-table-container {
	width: 100%;
	height: 180px;
	overflow: auto;
	background: white;
}

.payments-table {
	width: 100%;
	border-collapse: collapse;
}

.payments-table tr:first-child td {
	padding: 15px;
	font-weight: bold;
}

.services-table td {
	padding: 5px;
}

.services-table {
	border-collapse: collapse;
}

.services-table tr:first-child td {
	font-weight: bold;
	border-bottom: 1px solid grey;
}

.group-sheet {
	border: 1px solid #6ec276 !important;
}

>>> .calculation-failed
	.v-input
	.v-input__control
	.v-input__slot
	.v-text-field__slot
	input {
	color: red !important;
}
</style>
